export default __webpack_public_path__ + "static/media/1690-1696.e21ffeac.jpg";